import SearchBar from '../SearchBar/index.web';

export default SearchBar;
